import { render, staticRenderFns } from "./PendingModal.vue?vue&type=template&id=b9b06444&"
import script from "./PendingModal.vue?vue&type=script&lang=js&"
export * from "./PendingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports